import { STATES } from './states';

export const PROFILE_FIELDS = {
  fullName: {
    label: 'Name',
  },
  prefix: {
    label: 'Prefix',
  },
  dateOfBirth: {
    label: 'Date of Birth',
    formatter: (dob: string) => {
      return dob
        .split('-')
        .reverse()
        .join('/');
    },
  },
  phone: {
    label: 'Phone Number',
  },
  gender: {
    label: 'Gender',
    formatter: (gender: string) => {
      return gender.toUpperCase();
    },
  },
  maritalStatus: {
    label: 'Marital Status',
  },
  pan: {
    label: 'PAN',
  },
  adhar: {
    label: 'Aadhaar Number',
  },
  email: {
    label: 'Email',
  },
  kycStatus: {
    label: 'KYC Status',
  },
  nationality: {
    label: 'Nationality',
  },
  pincode: {
    label: 'Pincode',
  },
  state: {
    label: 'State',
    formatter: (stateCode: string) => {
      return STATES.filter((state: any) => state.value === stateCode)[0].label;
    },
  },
  city: {
    label: 'City',
  },
  district: {
    label: 'District',
  },
  country: {
    label: 'Country',
  },
  fathersOrSpouseFirstName: {
    label: "Father's or Spouse Name",
  },
  nomineeAdded: {
    label: 'Want to add a Nominiee?',
    formatter: (value: boolean = false) => {
      return value ? 'Yes' : 'No';
    },
  },
  nomineeName: {
    label: 'Nominee Name',
  },
  nomineeRelation: {
    label: 'Nominee Relation',
  },
  nomineeDateOfBirth: {
    label: 'Nominee Date of Birth',
    formatter: (dob: string) => {
      return dob
        .split('-')
        .reverse()
        .join('/');
    },
  },
  annualIncomeCategory: {
    label: 'Annual Income Category',
  },
  countryOfBirth: {
    label: 'Country of Birth',
  },
  isTaxPayerOutsideIndia: {
    label: 'Paying tax outside of India?',
  },
  placeOfBirth: {
    label: 'Place of Birth',
  },
  sourceOfWealth: {
    label: 'Source of Wealth',
  },
  accountNo: {
    label: 'Account No.',
  },
  ifscCode: {
    label: 'IFSC Code',
  },
  cityOfBank: {
    label: 'City of Bank',
  },
  nameOfBank: {
    label: 'Bank Name',
  },
  bankCode: {
    label: 'Bank Code',
  },
  bank: {
    label: 'Bank',
  },
  accountType: {
    label: 'Account Type',
  },
  branchName: {
    label: 'Branch',
  },
};



// WEBPACK FOOTER //
// ./constants/profileFields.ts